import React, {useState} from 'react'
import './styles/input-icon.css'
import DarkEmail from '../../media/felsv/dark_message_icon.svg'
import SecondaryMessage from '../../media/felsv/secondary_message_icon.svg'

const styleIcon = 'ii-icon'

const InputIcon = (props: any) => {
  const [className, setClassName] = useState(styleIcon)
  const [secondary, setSecondary] = useState(false)

  const onMouseOver = () => setClassName(`${className} hover`)
  const onMouseOut = () => setClassName(className.replace(' hover', ''))

  const onFocus = () => {
    setSecondary(true)
    setClassName(`${className} focus-visible`)
  }
  const onBlur = (e: any) => {
    setClassName(className.replace(' focus-visible', ''))
    setSecondary(false)
    if (props.onBlur) props.onBlur(e)
  }

  return (
    <div className='ii-input-container'>
      <div className={className}>
        <img
          src={secondary ? props.secondaryIcon ?? SecondaryMessage : props.darkIcon ?? DarkEmail}
          alt={props.name ?? 'name'}
          style={{width: 20, height: 20}}
        />
      </div>
      <input autoComplete='off'
        className='ii-input-field m'
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        onFocus={onFocus}
        onBlur={onBlur}
        type={props.type ?? 'text'}
        name={props.name ?? 'name'}
        data-name={props.dataName ?? 'dataname'}
        placeholder={props.placeholder ?? 'placeholder'}
        id={props.id ?? 'id'}
        onChange={props.onChange}
        value={props.value ?? ''}
        autoFocus={props.autoFocus ?? false}
        disabled={props.disabled ?? false}
        maxLength={props.maxLength}
        minLength={props.minLength}
      />
    </div>
  )
}

export default InputIcon
